import Footer from "../../../common/footer/Footer";
import Header from "../../../common/header/Header";
import Loader from '../../../../loader/Loader'

import { Get_Pooja_Category_List, Get_Pooja_List_Category } from '../../../../api/pooja/Pooja'
import { toast } from "react-toastify";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import { useNavigate } from "react-router-dom";
import { useEffect, useState } from "react";
import { FaSearch } from "react-icons/fa";
import { User_Authentication } from '../../../../user_authentication/User_Authentication'
import { IMG_BASE_URL, WEB_DOMAIN_KEY } from "../../../../config/Config";
import { Helmet } from "react-helmet";
import { get_Page_Seo } from "../../../../api/global/Global";
import parse from 'html-react-parser';

const Pooja = () => {
    const navigate = useNavigate()
    const [pageSeo, set_Page_Seo] = useState({})
    const [isOpen, setIsOpen] = useState(false);
    const [showLocationPopup, setShowLocationPopup] = useState(false)
    const [zipcode, setZipcode] = useState("");
    const [selectedCity, setSelectedCity] = useState(null);
    const [selectedLocationType, setLocationType] = useState("");
    const [isLoading, setIsLoading] = useState(false)

    const [selectedLang, setSelectedLang] = useState("");
    const [pooja_Category, set_Pooja_Category] = useState([]);
    const [featured_Pooja, set_Featured_Pooja] = useState([]);
    const [languageList, set_Language_List] = useState([]);
    const [locationList, set_Location_List] = useState([]);
    const [filteredLocationList, setFilteredLocationList] = useState([]); // What you display

    useEffect(() => {
        const fetchPoojaData = async () => {
            setIsLoading(true);
            try {
                const token = User_Authentication();
                let response;

                if (!token) {
                    // No authentication
                    response = await Get_Pooja_Category_List();
                } else {
                    // Authenticated
                    response = await Get_Pooja_List_Category({ Authorization: `Bearer ${token}` });
                }

                const resData = response?.data || response?.response?.data;

                if (resData?.status == 200) {
                    set_Pooja_Category(resData?.data?.pooja_category || []);
                    set_Featured_Pooja(resData?.data?.featured_pooja || []);
                    set_Location_List(resData?.data?.location || []);
                    set_Language_List(resData?.data?.language || []);
                    setFilteredLocationList(resData?.data?.location || []);
                }
                if (resData?.status == 401) {
                    localStorage.removeItem("user_token");
                    localStorage.removeItem("user_is_active");
                    const publicRes = await Get_Pooja_Category_List();
                    const publicData = publicRes?.data || publicRes?.response?.data;
                    set_Pooja_Category(publicData?.data?.pooja_category || []);
                    set_Featured_Pooja(publicData?.data?.featured_pooja || []);
                    set_Location_List(publicData?.data?.location || []);
                    set_Language_List(publicData?.data?.language || []);
                    setFilteredLocationList(publicData?.data?.location || []);
                }
                if (resData?.status == 500) {
                    toast.error(resData?.message || "Something went wrong!");
                    navigate('/user-login');
                } else {
                    console.warn("Unexpected response:", resData);
                }

            } catch (error) {
                console.error("Error fetching pooja list:", error);
            } finally {
                setIsLoading(false);
            }
        };

        fetchPoojaData();
    }, []);


    const poojaLocation = JSON.parse(localStorage.getItem("poojaLocation"));
    const language = localStorage.getItem("selectedLanguage")

    useEffect(() => {
        const language = localStorage.getItem("selectedLanguage");
        const location = JSON.parse(localStorage.getItem("poojaLocation"));

        if (!language) {
            const timer = setTimeout(() => {
                setIsOpen(true); // Show language popup
            }, 1000); // or 10000 for 10s delay

            return () => clearTimeout(timer);
        } else if (!location) {
            const timer = setTimeout(() => {
                setShowLocationPopup(true); // Show location popup
            }, 1000);

            return () => clearTimeout(timer);
        }
    }, []);

    useEffect(() => {
        const storedLang = localStorage.getItem("selectedLanguage");
        if (storedLang) {
            setSelectedLang(storedLang);
        }
    }, []);

    const handleLanguageClick = (lang) => {
        setSelectedLang(lang);
    };

    const handleContinue = () => {
        if (selectedLang) {
            localStorage.setItem("selectedLanguage", selectedLang);
            setIsOpen(false); // close language popup

            const hasLocation = JSON.parse(localStorage.getItem("poojaLocation"));
            if (!hasLocation) {
                // Show location popup immediately
                setShowLocationPopup(true);
            }
        }
    };

    useEffect(() => {
        const storedLocation = JSON.parse(localStorage.getItem("poojaLocation"));
        if (storedLocation) {
            setSelectedCity(storedLocation);
        }
    }, []);

    const onClose = () => {
        setShowLocationPopup(false);
    };

    const handleLocationContinue = () => {
        if (selectedCity) {
            const selectedData = {
                zipcode,
                selectedCity,
                type: selectedLocationType
            };
            localStorage.setItem("poojaLocation", JSON.stringify(selectedData));
            setShowLocationPopup(false);
        }
    };

    const slidesToShow = pooja_Category
        ?.length < 4 ? pooja_Category?.length : 4;

    const settings = {
        infinite: pooja_Category?.length > 1,
        speed: 1000,
        slidesToShow: slidesToShow,
        slidesToScroll: 1,
        autoplay: pooja_Category?.length > 1,
        autoplaySpeed: 2000,
        arrows: pooja_Category?.length > 1,
        variableWidth: false,
        responsive: [
            {
                breakpoint: 1400,
                settings: {
                    slidesToShow: pooja_Category?.length < 4 ? pooja_Category?.length : 4,
                    variableWidth: false,
                },
            },
            {
                breakpoint: 1300,
                settings: {
                    slidesToShow: pooja_Category?.length < 4 ? pooja_Category?.length : 4,
                    variableWidth: false,
                },
            },
            {
                breakpoint: 1024,
                settings: {
                    slidesToShow: pooja_Category?.length < 3 ? pooja_Category?.length : 3,
                    variableWidth: false,
                },
            },
            {
                breakpoint: 768,
                settings: {
                    slidesToShow: pooja_Category?.length < 2 ? pooja_Category?.length : 2,
                    variableWidth: false,
                },
            },
            {
                breakpoint: 480,
                settings: {
                    slidesToShow: 1,
                    variableWidth: false,
                },
            },
        ],
    };

    const slideToShowFeaturedPooja = featured_Pooja?.length < 5 ? featured_Pooja?.length : 5
    const settings_featured = {
        infinite: featured_Pooja?.length > 1,
        speed: 500,
        slidesToShow: slideToShowFeaturedPooja,
        slidesToScroll: 1,
        autoplay: featured_Pooja?.length > 1,
        autoplaySpeed: 2000,
        arrows: featured_Pooja?.length > 1,
        variableWidth: false,
        responsive: [
            {
                breakpoint: 1300,
                settings: {
                    slidesToShow: featured_Pooja?.length < 4 ? featured_Pooja?.length : 4,
                    variableWidth: false,
                },
            },
            {
                breakpoint: 1024,
                settings: {
                    slidesToShow: featured_Pooja?.length < 3 ? featured_Pooja?.length : 3,
                    variableWidth: false,
                },
            },
            {
                breakpoint: 768,
                settings: {
                    slidesToShow: featured_Pooja?.length < 2 ? featured_Pooja?.length : 2,
                    variableWidth: false,
                },
            },
            {
                breakpoint: 480,
                settings: {
                    slidesToShow: 1,
                    variableWidth: false,
                },
            },
        ],
    };

    useEffect(() => {
        const Get_Page_Seo = async () => {
            setIsLoading(true);
            try {
                const response = await get_Page_Seo()
                if (response?.data?.status == 200) {
                    const seo = response?.data?.data?.seo
                    const filterSeoPage = seo?.find(page => page?.page_name === "Pooja Main Page")
                    set_Page_Seo(filterSeoPage)
                }
            } catch (error) {
                console.error(error)
            } finally {
                setIsLoading(false);
            }
        }

        Get_Page_Seo()
    }, [])

    return (
        <>
            <Helmet>
                <title>{pageSeo?.meta_title}</title>
                <meta name="description" content={pageSeo?.meta_description} />
                <link rel="canonical" href={`${WEB_DOMAIN_KEY}pooja`} />
                <link rel="alternate" hreflang="en-us" href={`${WEB_DOMAIN_KEY}pooja`} />
            </Helmet>

            {isLoading ? (
                <Loader />
            ) : (
                <>
                    <Header />
                    <section className='banner-section'>
                        <div className={`${pageSeo?.image ? "block" : "hidden"} relative`}>
                            <img src={`${IMG_BASE_URL}${pageSeo?.image}`} alt={pageSeo?.alt
                            } className='w-full h-[300px]' />
                        </div>
                    </section>
                    <section className="gi-blog-section py-[40px] max-[767px]:py-[30px] wow fadeInUp"
                        style={{ visibility: "visible", animationName: "fadeInUp" }}>
                        <div
                            className="mx-auto min-[1400px]:max-w-[1320px] min-[1200px]:max-w-[1140px] min-[992px]:max-w-[960px] min-[768px]:max-w-[720px] min-[576px]:max-w-[540px]  px-3">
                            <div className="w-full mb-[-24px]">
                                <div className="flex gap-3 items-center">
                                    <div onClick={() => { setIsOpen(true) }} className="cursor-pointer text-gray-900 text-xs font-medium hover:underline">{language ? `${language}` : "Select Language"}</div> <b>|</b>
                                    <div className="cursor-pointer text-gray-900 text-xs font-medium hover:underline" onClick={() => { setShowLocationPopup(true) }}>{poojaLocation?.selectedCity ? `${poojaLocation?.selectedCity}` : "Select Location"}</div>
                                </div>
                                <div className="">
                                    <div className='title text-center mb-2'>
                                        <h1 className='text-3xl text-gray-900 font-bold bodonibook_font'>Featured Poojas</h1>
                                        {/* <div className='border-b-2 border-gray-900 w-[200px] mx-auto inline-block'></div> */}
                                    </div>
                                    {/* <div className='grid grid-cols-5 gap-4 my-6 inline-block'> */}
                                    <Slider {...settings_featured} className="z-0 ">
                                        {featured_Pooja?.length > 0 && featured_Pooja?.map((featured_result) => (
                                            <div className="p-2 py-5">
                                                <div className='p-4 rounded-xl shadow-custome scale-100 hover:scale-120 hover:shadow-2xl text-center cursor-pointer'>
                                                    <div
                                                        onClick={() => {
                                                            navigate(`/pooja-detail/${featured_result?.slug}`)
                                                        }
                                                        }>
                                                        <img className='rounded-lg w-full size-56' src={`${IMG_BASE_URL}${featured_result?.image}`} alt={featured_result?.image_alt} />
                                                        <h4 className='text-gray-900 line-clamp-1 font-semibold text-[14px] mt-3'>{featured_result?.name}</h4>

                                                    </div>
                                                </div>
                                            </div>
                                        ))}
                                    </Slider>
                                    {/* </div> */}
                                </div>
                            </div>
                        </div>
                    </section>
                    <section className="gi-blog-section pt-3 max-[767px]:py-[30px] mb-20 inline-block w-full wow fadeInUp"
                        style={{ visibility: "visible", animationName: "fadeInUp" }}>
                        <div
                            className="mx-auto min-[1400px]:max-w-[1320px] min-[1200px]:max-w-[1140px] min-[992px]:max-w-[960px] min-[768px]:max-w-[720px] min-[576px]:max-w-[540px]  px-3">
                            <div className="w-full">
                                <div className="grid grid-cols-1 gap-2 items-center">
                                    <div className='title mb-3 text-center'>
                                        <h2 className='text-3xl text-gray-900 font-bold bodonibook_font'>Browse Pooja By Category</h2>

                                    </div>
                                </div>
                                <Slider {...settings} className="z-0 slider_views_poojs">
                                    {pooja_Category?.length > 0 ? pooja_Category?.map((cate_result) => (
                                        <div className="p-2 py-5">
                                            <div className='shadow-custome p-4 rounded-xl hover:shadow-cyan-100/50 text-center cursor-pointer'>
                                                <div
                                                    onClick={() => {
                                                        navigate(`/pooja/${cate_result?.slug}`)
                                                    }
                                                    }
                                                >
                                                    <img className='rounded-lg w-full size-56' src={`${IMG_BASE_URL}${cate_result?.image}`} alt={cate_result?.image_alt} />
                                                    <h4 className='text-gray-900 line-clamp-1 font-semibold text-[14px] mt-3'>{cate_result?.title}</h4>
                                                </div>
                                            </div>
                                        </div>
                                    )) : <div>Pooja category not found</div>}
                                    {/* </div> */}
                                </Slider>
                                <div class="text-center mt-3"><a class="text-[13px] uppercase border border-gray-400 text-gray-900 font-semibold px-6 py-3 hover:bg-red-700 hover:text-white" href="/all-pooja-category">View All</a></div>
                            </div>
                            <div className="sub__title text-gray-900 mt-6">{pageSeo?.description && parse(pageSeo?.description)}</div>
                        </div>
                    </section>

                    <div className="clearfixed float-left w-full inline-block"></div>

                    <Footer />
                    {isOpen && (
                        <div className="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-50">
                            <div className="bg-white rounded-lg w-full max-w-xl max-h-[90vh] overflow-y-auto shadow-xl relative">
                                <button onClick={() => {
                                    const defaultLang = languageList[0]?.language;
                                    const defaultCity = locationList[0]?.state;
                                    
                                    // Set states for internal consistency
                                    if (defaultLang) handleLanguageClick(defaultLang);
                                    if (defaultCity) setSelectedCity(defaultCity);
                                    setLocationType("in-person");
                                    
                                    // Manually write to localStorage synchronously to prevent stale state issues
                                    if (defaultLang) {
                                        localStorage.setItem("selectedLanguage", defaultLang);
                                    }
                                    if (defaultCity) {
                                        const selectedData = {
                                            zipcode: zipcode,
                                            selectedCity: defaultCity,
                                            type: "in-person"
                                        };
                                        localStorage.setItem("poojaLocation", JSON.stringify(selectedData));
                                    }
                                    
                                    setIsOpen(false);
                                    setShowLocationPopup(false);
                                }} className="absolute top-1 right-4  text-red-700 text-[30px]">
                                    &times;
                                </button>

                                <div className="">
                                    <div className="text-lg font-semibold p-3 px-4">Pick a Language</div>

                                    <div className='border-y  border-spacing-2 border-gray-300 flex flex-col mx-auto p-4'>
                                        <h2 className='text-[14px] font-medium mb-1'>Pick Priest / Culture Preference</h2>
                                        <div className="h-40 mb-4 py-2 overflow-hidden">
                                            <ul className="grid xs:grid-cols-2 sm:grid-cols-2 md:grid-cols-4 gap-3 shrink-0">
                                                {languageList?.map((language_result, ind) => (
                                                    <li className={`text-xs px-4 border font-medium  rounded-3xl leading-9 text-center line-clamp-2 xxs:line-clamp-1  cursor-pointer text-Default ${selectedLang == language_result?.language ? "bg-red-700 text-white border-red-700"
                                                        : "border-gray-300 text-gray-900 font-medium"}`}
                                                        onClick={() => handleLanguageClick(language_result?.language)}>{language_result?.language}</li>
                                                ))}
                                            </ul>
                                        </div>
                                    </div>
                                    <button className='px-4 py-2 bg-red-800 text-[13px] font-medium text-white rounded my-2 mx-4 float-right uppercase' onClick={handleContinue}>continue</button>
                                </div>
                            </div>
                        </div>
                    )}
                    {showLocationPopup && (
                        <div className="fixed inset-0 bg-black bg-opacity-40 flex items-center justify-center z-50">
                            <div className="bg-white rounded-lg w-full max-w-xl max-h-[90vh] overflow-y-auto shadow-xl relative">
                                {/* Close Button */}

                                <button onClick={() => {
                                    const defaultCity = locationList[0]?.state;
                                    
                                    if (defaultCity) {
                                        setSelectedCity(defaultCity);
                                        setLocationType("in-person");
                                        
                                        const selectedData = {
                                            zipcode: zipcode,
                                            selectedCity: defaultCity,
                                            type: "in-person"
                                        };
                                        localStorage.setItem("poojaLocation", JSON.stringify(selectedData));
                                    }
                                    setShowLocationPopup(false);
                                }} className="absolute top-1 right-4  text-red-700 text-[30px]">
                                    &times;
                                </button>


                                <div className="text-lg font-semibold p-3 px-4">Pick a Location</div>
                                {/* Zipcode Input */}
                                <div className="border-y  border-spacing-2 border-gray-300 flex flex-col mx-auto p-4">
                                    <div className="relative flex items-center border border-gray-300 rounded-full py-2 px-4 mb-4">
                                        <input
                                            type="text"
                                            value={zipcode}
                                            onChange={(e) => {
                                                const input = e.target.value
                                                setZipcode(input)

                                                if (input.trim() === "") {
                                                    setFilteredLocationList(locationList);
                                                    return;
                                                }
                                                const filtered = locationList.filter((loc) =>
                                                    loc?.state?.toLowerCase().includes(input.toLowerCase())
                                                );
                                                setFilteredLocationList(filtered);
                                            }
                                            }
                                            className="flex-1 text-gray-900 outline-none bg-transparent text-[13px] font-medium"
                                            placeholder="Enter City Name"
                                        />
                                        {zipcode && (
                                            <div className="absolute top-9 left-0 z-10 w-full bg-white border border-gray-200 rounded-lg mt-1 max-h-48 overflow-y-auto shadow">
                                                {filteredLocationList.length > 0 ? (
                                                    filteredLocationList.map((city) => (
                                                        <div
                                                            key={city?.id}
                                                            className="px-4 py-2 text-[13px] hover:bg-gray-100 cursor-pointer"
                                                            onClick={() => {
                                                                setSelectedCity(city?.state);
                                                                setZipcode(city?.state);
                                                                setFilteredLocationList([]);
                                                            }}
                                                        >
                                                            {city?.state}
                                                        </div>
                                                    ))
                                                ) : (
                                                    <div className="px-4 py-2 text-sm text-gray-700">No match found</div>
                                                )}
                                            </div>
                                        )}
                                        <FaSearch className="text-gray-700 w-4 h-4" />
                                    </div>
                                    {/* Detect My Location */}
                                    {/* <button className="flex items-center text-sm text-gray-600 gap-2 mb-4">
                                        <LocateFixed className="w-4 h-4" />
                                        Detect My Location
                                    </button> */}
                                    {/* E-Pooja Option */}
                                    {/* <p className="text-gray-800 font-medium mb-2">
                                    Online (Recorded/Live) – at a Vedic Centre or Temple
                                </p>
                                <button
                                    className={`px-4 py-1 border rounded-full text-sm mb-4 ${selectedLocationType === "e-pooja"
                                        ? "border-red-700 text-red-700 font-semibold"
                                        : "border-gray-300 text-gray-600"
                                        }`}
                                    onClick={() => setLocationType("e-pooja")}
                                >
                                    E-Pooja
                                </button> */}
                                    {/* In-Person Locations */}
                                    <p className="text-gray-900 font-medium mb-2">
                                        In Person (At Home/Vedic Centre)
                                    </p>
                                    <div className="grid xs:grid-cols-2 sm:grid-cols-2 md:grid-cols-4 gap-2 max-h-60 overflow-y-auto pr-2">
                                        {locationList.map((city) => (
                                            <button
                                                key={city?.id}
                                                onClick={() => {
                                                    setSelectedCity(city?.state);
                                                    setLocationType("in-person");
                                                }}
                                                className={`text-xs px-4 border font-medium  rounded-3xl leading-9 text-center line-clamp-1 xxs:line-clamp-1  cursor-pointer text-Default ${selectedCity == city?.state ? "bg-red-700 text-white border-red-700"
                                                    : "border-gray-300 text-gray-900 font-medium"}`}
                                            >
                                                {city?.state?.length > 6 ? `${city?.state?.slice(0, 14)}...` : city?.state}
                                            </button>
                                        ))}
                                    </div>
                                </div>
                                {/* Continue Button */}
                                <div className="flex justify-end">
                                    <button
                                        className="px-4 py-2 bg-red-800 text-[13px] font-medium text-white rounded my-2 mx-4 float-right uppercase"
                                        onClick={handleLocationContinue}
                                    >
                                        Continue
                                    </button>
                                </div>
                            </div>
                        </div>
                    )}
                </>
            )}
        </>
    );
}

export default Pooja